"use client"

import { useWallet } from "@/lib/wallet-provider"

/**
 * Thin auth adapter over the BRC-100 wallet connection.
 * The wallet identity key IS the account - no OAuth roundtrip, no profile
 * server. Kept as its own hook so gameplay components don't need to know
 * about wallet internals.
 */
export function useAuth() {
  const { status, identityKey, connect, disconnect, lastError } = useWallet()

  return {
    identityKey,
    isAuthenticated: status === "connected" && !!identityKey,
    isLoading: status === "connecting",
    error: lastError,
    connect,
    disconnect,
  }
}
